import React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { isProduction } from './helpers';

function useCurrentBreakpoint() {
  const theme = useTheme();
  const isXxxxxl = useMediaQuery(theme.breakpoints.up('xxxxl'));
  const isXxxxl = useMediaQuery(theme.breakpoints.up('xxxl'));
  const isXxl = useMediaQuery(theme.breakpoints.up('xxl'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  if (isXxxxxl) return 'xxxxl';
  if (isXxxxl) return 'xxxl';
  if (isXxl) return 'xxl';
  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isMd) return 'md';
  if (isSm) return 'sm';
  return 'xs';
}

function BreakpointBanner() {
  const breakpoint = useCurrentBreakpoint();

  if (isProduction()) return null;

  return <Typography className="mss__breakpointBanner">{breakpoint}</Typography>;
}

export default BreakpointBanner;
